var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.245 0 0 2.245 0 5C0 7.755 2.245 10 5 10C7.755 10 10 7.755 10 5C10 2.245 7.755 0 5 0ZM7 5.375H5.375V7C5.375 7.205 5.205 7.375 5 7.375C4.795 7.375 4.625 7.205 4.625 7V5.375H3C2.795 5.375 2.625 5.205 2.625 5C2.625 4.795 2.795 4.625 3 4.625H4.625V3C4.625 2.795 4.795 2.625 5 2.625C5.205 2.625 5.375 2.795 5.375 3V4.625H7C7.205 4.625 7.375 4.795 7.375 5C7.375 5.205 7.205 5.375 7 5.375Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataPlusIcon);
export default __webpack_public_path__ + "static/media/nodata-plus-icon.48ffe0207b80ce5e0b593c8d9d84e4dd.svg";
export { ForwardRef as ReactComponent };